module.exports = __webpack_public_path__ + "static/media/spinner.06821b7a.gif";